<template>
  <v-container fluid py-0 px-0 id="order-add-edit">
    <u-i-toolbar-admin :title="titlePage" :icon="icon"/>
    <v-layout align-center py-3 fill-height>
      <v-flex xs11>
        <v-form v-model="isForm" id="form-data" ref="refFormData">
          <v-layout row wrap>
            <v-flex xs12 sm12 md4 py-0 px-2>
              <v-toolbar height="32px" class="v-card" dark>
                <v-subheader class="px-0">
                  {{ $helpers.getProp(formData, 'department_from.company_name', '') }}
                </v-subheader>
              </v-toolbar>
              <v-list class="px-4 v-card">
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_from.address', '') }}
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_from.city', '') }}
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_from.country.name', '') }}
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_from.phone', '') }}
                </v-list-tile-content>
              </v-list>
            </v-flex>
            <v-flex xs6 sm6 md4 py-0 px-2>
              <v-toolbar height="32px" class="v-card" dark>
                <v-subheader class="px-0">
                  {{ $helpers.getProp(formData, 'department_to.company_name', '') }}
                </v-subheader>
              </v-toolbar>
              <v-list class="px-4 v-card">
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_to.address', '') }}
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_to.city', '') }}
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_to.country.name', '') }}
                </v-list-tile-content>
                <v-list-tile-content>
                  {{ $helpers.getProp(formData, 'department_to.phone', '') }}
                </v-list-tile-content>
              </v-list>
            </v-flex>
          </v-layout>
          <v-layout wrap pt-4>
            <v-flex xs12 sm12 md8 py-0 px-2>
              <v-data-table
                :headers="hasEuInvoice ? headersEu : headers"
                :items="products"
                :hide-actions="true"
                class="elevation-2"
              >
                <template v-if="hasEuInvoice" v-slot:headers="">
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center">Description Url</th>
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center" colspan="2">Net kg</th>
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center">Price</th>
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center">Quantity</th>
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center" colspan="2">Total Gross</th>
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center">Total Price</th>
                  <th class="font-weight-bold green lighten-1 white--text text-xs-center">HSCODE</th>
                </template>
                <template v-slot:items="{item}">
                  <template v-if="hasEuInvoice">
                    <tr
                      v-for="(product, productKey) in item.products"
                      :key="productKey"
                    >
                      <td class="text-xs-center" v-html="product.description"></td>
                      <td class="text-xs-center">{{ product.weight }}</td>
                      <td class="text-xs-center">kg</td>
                      <td class="text-xs-center">
                        {{ `${$helpers.getProp(formData, 'currency.symbol', '')}${product.price}` }}
                      </td>
                      <td class="text-xs-center">{{ product.quantity }}</td>
                      <td class="text-xs-center">{{ product.products_weight }}</td>
                      <td class="text-xs-center">kg</td>
                      <td class="text-xs-center">
                        {{ `${$helpers.getProp(formData, 'currency.symbol', '')}${product.total_price}` }}
                      </td>
                      <td class="text-xs-center">{{ product.hccode }}</td>
                    </tr>
                    <tr class="grey lighten-2">
                      <td class="text-xs-center"></td>
                      <td class="text-xs-center"></td>
                      <td class="text-xs-center"></td>
                      <td class="text-xs-center font-weight-bold">SUM</td>
                      <td class="text-xs-center font-weight-bold">{{ item.total_quantity }}</td>
                      <td class="text-xs-center font-weight-bold">{{ item.total_weight }}</td>
                      <td class="text-xs-center font-weight-bold">kg</td>
                      <td class="text-xs-center font-weight-bold">
                        {{ `${$helpers.getProp(formData, 'currency.symbol', '')}${item.total_amount}` }}
                      </td>
                      <td class="text-xs-center"></td>
                    </tr>
                  </template>
                  <template v-else>
                    <td class="text-xs-center" v-html="item.description"></td>
                    <td class="text-xs-center">{{ item.quantity }}</td>
                    <td class="text-xs-center">{{ item.total_price }}</td>
                  </template>
                </template>
                <template v-slot:footer>
                  <template v-if="hasEuInvoice">
                    <tr></tr>
                    <tr class="green lighten-4 font-weight-bold">
                      <td colspan="4"></td>
                      <td class="text-xs-center">Quantity</td>
                      <td class="text-xs-center" colspan="2">Total Gross</td>
                      <td class="text-xs-center">Total Price</td>
                      <td></td>
                    </tr>
                    <tr class="green lighten-4 font-weight-bold">
                      <td colspan="4" class="text-xs-right">SUM</td>
                      <td class="text-xs-center">{{ formData.total_quantity }}</td>
                      <td class="text-xs-center">{{ formData.total_weight }}</td>
                      <td class="text-xs-center">kg</td>
                      <td class="text-xs-center">
                        {{ `${$helpers.getProp(formData, 'currency.symbol', '')}${formData.total_amount}` }}
                      </td>
                      <td></td>
                    </tr>
                  </template>
                  <template v-else>
                    <td
                      v-if="formData.total_amount"
                      :colspan="headers.length"
                      class="text-xs-center"
                    >
                      Total:
                      <strong>
                        {{ $helpers.getProp(formData, 'total_amount', '') }}
                      </strong>
                    </td>
                  </template>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout row wrap py-3>
          <v-flex xs12 sm4 md2 lg1>
            <v-btn @click="onPrint" block black color="info">
              <v-icon class="mr-1">print</v-icon>
              Print
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md4 lg1 pl-2>
            <v-btn @click="onCsv" black block color="info">
              <v-icon class="mr-1">file_present</v-icon>
              Csv
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import UIToolbarAdmin from '@/components/UI/ToolbarAdmin';
import ReportsFlightsService from '@/services/Admin/ReportsFlights';

export default {
  name: 'ConsolidatedInvoice',
  props: {
    id: {
      required: false,
      type: [String, Number],
      default: 0,
    },
  },
  components: {
    UIToolbarAdmin
  },
  metaInfo() {
    const titleTemplate = `%s - Admin | ${this.titlePage}`
    return {titleTemplate}
  },
  data: () => ({
    formData: {},
    isForm: true,
    headersEu: [
      {text: 'Description Url'},
      {text: 'Net kg'},
      {text: 'Price'},
      {text: 'Quantity'},
      {text: 'Total Gross'},
      {text: 'Total Price'},
      {text: 'HSCODE'},
    ],
    headers: [
      {
        text: 'Products',
        value: 'description',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Quantity',
        value: 'quantity',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text'
      },
      {
        text: 'Total Price',
        value: 'total_price',
        align: 'center',
        sortable: false,
        class: 'font-weight-bold grey darken-2 white--text',
      },
    ]
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.getConsolidatedInvoice(this.$route.params.id)
        .then(response => {
          this.formData = this.$helpers.getProp(response, 'data', {});
        })
        .catch(error => {
          this.$store.dispatch('setError', this.$helpers.getProp(error, 'response.data.message', 'Something went wrong!'));
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    onPrint() {
      this.$store.commit('setLoading', true);
      ReportsFlightsService.getConsolidatedInvoicePdf(this.$route.params.id)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('target', '_blank');
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.$store.dispatch('setError', error.response.message);
        })
        .finally(() => this.$store.commit('setLoading', false));
    },
    onCsv() {
      const target = `${this.$apiRouter.adminReportsFlight}/consolidated-invoice/csv/${this.$route.params.id}`;
      this.axios.get(target, {responseType: 'blob'})
        .then(response => {
          const fileName = `Consolidated-invoice-${this.$route.params.id}`
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', `${fileName}.csv`); //or any other extension
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })
        .catch(error => {
          this.$store.dispatch('setError', this.$helpers.getProp(error, 'response.data.message', 'Something went wrong!'));
        })
        .finally(() => this.$store.commit('setLoading', false));
    }
  },
  computed: {
    hasEuInvoice() {
      return this.$helpers.getProp(this.formData, 'department_from.name', '').toLowerCase() === 'frankfurt';
    },
    products() {
      const {getProp, forEach} = this.$helpers;
      if (this.hasEuInvoice) {
        const res = [];
        const data = getProp(this.formData, 'data', {});
        forEach(data, (item, hccode) => {
          forEach(item.products, product => {
            product.hccode = hccode;
          })
          res.push(item);
        })
        return res.reverse();
      }
      return getProp(this.formData, 'data', [])
    },
    titlePage() {
      return 'Consolidated Invoice #' + (this.$route.params.id || '');
    },
    icon() {
      return 'flight';
    }
  }
}
</script>
